var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m30.7 27.1-5.8-5.8c-.3-.3-.6-.4-1-.4H23c1.5-2.1 2.5-4.6 2.5-7.6 0-6.7-5.5-12.1-12.1-12.1S1 6.5 1 13.2s5.5 12.1 12.1 12.1c2.8 0 5.5-.9 7.6-2.5v.9c0 .4.1.7.4 1l5.8 5.8c.4.4 1.5.4 1.9 0l1.6-1.6c.7-.4.7-1.3.3-1.8m-17.6-6.2c-4.2 0-7.6-3.4-7.6-7.6s3.4-7.6 7.6-7.6 7.6 3.4 7.6 7.6c-.1 4.1-3.4 7.6-7.6 7.6"
})));
export default SvgIconSearch;